import {
  daysBetween,
  PRESETS,
  presetPeriod,
  type BusinessDate,
  type Period,
  type Preset,
} from '@crm/shared/time';

// Presets live in @crm/shared/time so the static demo export (ADR-027) uses the same periods.
export { DEFAULT_PRESET, PRESETS, presetPeriod, type Preset } from '@crm/shared/time';

/** Which preset a period equals (so the picker can show its name), or `custom`. */
export function detectPreset(period: Period, today: BusinessDate): Preset {
  for (const preset of PRESETS) {
    const candidate = presetPeriod(preset, today);
    if (candidate && candidate.from === period.from && candidate.to === period.to) return preset;
  }
  return 'custom';
}

export const MAX_PERIOD_DAYS = 400;

export type PeriodProblem = 'invalid' | 'tooLong' | null;

export function checkPeriod(period: Period): PeriodProblem {
  const days = daysBetween(period.from, period.to) + 1;
  if (days < 1) return 'invalid';
  return days > MAX_PERIOD_DAYS ? 'tooLong' : null;
}

/** Whether a period reaches today, so its figures still change (shorter cache, refresh timer). */
export const includesToday = (periodTo: BusinessDate, today: BusinessDate): boolean =>
  daysBetween(periodTo, today) <= 0;
